import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useMemo, useState } from "react";
export var TYPE_LARGE = "large";
export var TYPE_THIN = "thin";
export var useIsDraggedOver = function () {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    counter = _useState2[0],
    setCounter = _useState2[1],
    funcs = useMemo(function () {
      return {
        pushDrag: function () {
          return setCounter(function (prev) {
            return prev + 1;
          });
        },
        popDrag: function () {
          return setCounter(function (prev) {
            return Math.max(0, prev - 1);
          });
        },
        resetIsDraggedOver: function () {
          return setCounter(0);
        }
      };
    }, []);
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, funcs), {}, {
      isDraggedOver: counter > 0
    });
  }, [funcs, counter]);
};
export var getFileName = function (filePathOrObj) {
  var filePath = "object" === _typeof(filePathOrObj) ? filePathOrObj.name : filePathOrObj;
  return null == filePath ? void 0 : filePath.split(/[/\\]/).pop();
};